import {
	API_DELETE_LABAPPOINTMENT,
	API_GET_ALL_BY_DATE_LABAPPOINTMENT,
	API_GET_FOLDERS_PATIENT_FOR_LABAPPOINTMENT,
	API_PATCH_LABAPPOINTMENT,
	API_POST_LABAPPOINTMENT,
	API_GET_ALL_BETWEEN_DATES_LABAPPOINTMENT,
	RESET_LIST,
	API_GET_ALL_BY_DATE_LABAPPOINTMENT_BY_GROUP,
} from "actions/labAppointment";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_GET_ALL_BY_DATE_LABAPPOINTMENT]: {
		default: (date, center) => `/labAppointment/${date}/center/${center}`,
		v2: (date, center) => `/lab-appointments/${date}/center/${center}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_ALL_BETWEEN_DATES_LABAPPOINTMENT]: {
		default: (startDate, endDate, centerId, boxId) => `/labAppointment/${startDate}/${endDate}/center/${centerId}/${boxId || 0}`,
		v2: (startDate, endDate, centerId) => `/lab-appointments/${centerId}/${startDate}/${endDate}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_POST_LABAPPOINTMENT]: {
		default: (folderId) => folderId ? `/labAppointment/${folderId}` : `/labAppointment`,
		v2: () => `/lab-appointments`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_PATCH_LABAPPOINTMENT]: {
		default: (id) => `/labAppointment/${id}`,
		v2: (id) => `/lab-appointments/${id}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_DELETE_LABAPPOINTMENT]: {
		default: (id) => `/labAppointment/${id}`,
		v2: (id) => `/lab-appointments/${id}`,
		currentClient: DEFAULT_CLIENT,
	},
};

const adaptLabAppointmentRequest = (labAppointment, currentClient) => {
	if (!labAppointment || currentClient !== V2_CLIENT) {
		return labAppointment;
	}

	const adapted = { ...labAppointment };

	// Legacy payload uses `patient`, `center`, `box` + snake_case flags.
	if (adapted.patient !== undefined && adapted.patientId === undefined) {
		adapted.patientId = adapted.patient;
	}
	if (adapted.center !== undefined && adapted.centerId === undefined) {
		adapted.centerId = adapted.center;
	}

	// `box` can be an object (from session) or an id; v7 expects boxId.
	if (adapted.box !== undefined && adapted.boxId === undefined) {
		if (typeof adapted.box === "object" && adapted.box !== null) adapted.boxId = adapted.box.id;
		else adapted.boxId = adapted.box;
	}

	if (adapted.picken_dohem !== undefined && adapted.pickenDohem === undefined) {
		adapted.pickenDohem = adapted.picken_dohem;
	}
	if (adapted.last_repetition !== undefined && adapted.lastRepetition === undefined) {
		adapted.lastRepetition = adapted.last_repetition;
	}

	// Keep only v7 DTO fields
	return {
		id: adapted.id,
		_date: adapted._date,
		_time: adapted._time,
		status: adapted.status,
		patientId: adapted.patientId,
		centerId: adapted.centerId,
		boxId: adapted.boxId,
		pickenDohem: adapted.pickenDohem,
		urgent: adapted.urgent,
		lastRepetition: adapted.lastRepetition,
		folderId: adapted.folderId,
	};
};

export function getLabAppointments(date, center) {
	const version = getVersion(API_GET_ALL_BY_DATE_LABAPPOINTMENT);
	const url = typeof version.path === 'function' ? version.path(date, center) : version.path;
	return {
		type: API_GET_ALL_BY_DATE_LABAPPOINTMENT,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}

export function getLabAppointmentsByCenterGroup(date, centerGroup, done = false, page = 1) {
	return {
		type: API_GET_ALL_BY_DATE_LABAPPOINTMENT_BY_GROUP,
		payload: {
			request: {
				url: `/labAppointment/${date}/center-group/${centerGroup}`,
				params: { done, page },
			},
		},
	};
}

export function getLabAppointmentsBetweenDates(startDate, endDate, centerid, done, search, page = 1, size, centers, box = null, box_id = 0) {
	const version = getVersion(API_GET_ALL_BETWEEN_DATES_LABAPPOINTMENT);
	
	if (version.currentClient === V2_CLIENT) {
		const url = typeof version.path === 'function' ? version.path(startDate, endDate, centerid) : version.path;
		return {
			type: API_GET_ALL_BETWEEN_DATES_LABAPPOINTMENT,
			payload: {
				client: version.currentClient,
				request: {
					url,
					params: { done, page, size, search, centers, box: !!box },
				},
			},
		};
	}
	
	const url = typeof version.path === 'function' ? version.path(startDate, endDate, centerid, box_id) : version.path;
	return {
		type: API_GET_ALL_BETWEEN_DATES_LABAPPOINTMENT,
		payload: {
			client: version.currentClient,
			request: {
				url,
				params: { done, page, size, search, centers, box: !!box },
			},
		},
	};
}

export function getPatientFoldersForAppointment(id) {
	return {
		type: API_GET_FOLDERS_PATIENT_FOR_LABAPPOINTMENT,
		payload: {
			request: {
				url: `/folders/patient/${id}`,
			},
			id: id,
		},
	};
}

export function postLabAppointment(labAppointment, folderId) {
	const version = getVersion(API_POST_LABAPPOINTMENT);
	
	if (version.currentClient === V2_CLIENT) {
		const url = typeof version.path === 'function' ? version.path() : version.path;
		const data = adaptLabAppointmentRequest(labAppointment, version.currentClient);
		return {
			type: API_POST_LABAPPOINTMENT,
			payload: {
				client: version.currentClient,
				request: {
					url,
					method: "POST",
					data,
				},
			},
		};
	}
	
	const url = typeof version.path === 'function' ? version.path(folderId) : version.path;
	return {
		type: API_POST_LABAPPOINTMENT,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "POST",
				data: labAppointment,
			},
		},
	};
}

export function patchLabAppointment(labAppointment, dateRounds) {
	const version = getVersion(API_PATCH_LABAPPOINTMENT);
	const url = typeof version.path === 'function' ? version.path(labAppointment.id) : version.path;
	const data = adaptLabAppointmentRequest(labAppointment, version.currentClient);
	return {
		type: API_PATCH_LABAPPOINTMENT,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "PATCH",
				data,
			},
			currentDate: dateRounds,
		},
	};
}

export function deleteLabAppointment(labAppointment) {
	const version = getVersion(API_DELETE_LABAPPOINTMENT);
	const url = typeof version.path === 'function' ? version.path(labAppointment.id) : version.path;
	return {
		type: API_DELETE_LABAPPOINTMENT,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "DELETE",
			},
			id: labAppointment.id,
		},
	};
}
export function resetLabAppointmentList() {
	return {
		type: RESET_LIST,
		payload: {},
	};
}
